import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc650fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wulian"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-tag" }, "物联", -1))
const _hoisted_3 = {
  key: 0,
  class: "i-item"
}
const _hoisted_4 = { class: "i-title" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "i-value" }
const _hoisted_8 = { class: "custom-title" }
const _hoisted_9 = {
  key: 0,
  class: "required"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { style: {"font-size":"14px","margin-left":"10px"} }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = {
  key: 5,
  class: "px-16px"
}
const _hoisted_14 = { class: "uf-sign__content" }
const _hoisted_15 = { style: {"margin":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_uf_signature = _resolveComponent("uf-signature")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_form, { onSubmit: $setup.onSubmit }, {
      default: _withCtx(() => [
        ($setup.storeInfo.data.iot_params?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.iot_params, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (item.is_show === '1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.energy_type_name) + _toDisplayString(item.title), 1),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(item.iot_params_value.time_name) + "更新", 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.iot_params_value.param_value) + _toDisplayString(item.iot_params_value.param_unit), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_cell_group, { inset: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.assembly_json, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.sort
              }, [
                _createVNode(_component_van_cell, { class: "title" }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1),
                    (item.is_checked == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (item.check_type === 'check_show')
                  ? (_openBlock(), _createBlock(_component_van_cell, {
                      key: 0,
                      class: "value",
                      value: item.content
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_radio')
                  ? (_openBlock(), _createBlock(_component_van_radio_group, {
                      key: 1,
                      modelValue: $setup.storeInfo.result[index].result,
                      "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].result) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, (option) => {
                          return (_openBlock(), _createBlock(_component_van_radio, {
                            key: option.key,
                            class: _normalizeClass(option.is_warning === 1 ? 'red' : ''),
                            name: option.key
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "name"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_checkbox')
                  ? (_openBlock(), _createBlock(_component_van_checkbox_group, {
                      key: 2,
                      modelValue: $setup.storeInfo.result[index].result,
                      "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].result) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, (option) => {
                          return (_openBlock(), _createBlock(_component_van_checkbox, {
                            key: option.key,
                            class: _normalizeClass(option.is_warning === 1 ? 'red' : ''),
                            name: option.key
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "name"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_number')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_van_stepper, {
                        class: "px-16px",
                        "input-width": "60px",
                        min: -99999999,
                        "decimal-length": item.digit_num,
                        placeholder: `(${item.min_value} ~ ${item.max_value})`,
                        modelValue: $setup.storeInfo.result[index].result,
                        "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].result) = $event)
                      }, null, 8, ["decimal-length", "placeholder", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("i", _hoisted_11, _toDisplayString(item.unit), 1),
                      _createElementVNode("i", {
                        style: _normalizeStyle(
                `font-size: 14px; margin-left: 10px;color:${$setup.storeInfo.result[index].result < item.min_value ||
                  $setup.storeInfo.result[index].result > item.max_value} ? 'red' : '#666666'`
              )
                      }, _toDisplayString(`(${item.min_value} ~ ${item.max_value})`), 5)
                    ]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_textarea')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_van_field, {
                        modelValue: $setup.storeInfo.result[index].result,
                        "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].result) = $event),
                        rows: "3",
                        autosize: "",
                        label: "",
                        type: "textarea",
                        maxlength: item.word_num,
                        placeholder: `请输入${item.title}`,
                        "show-word-limit": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_pic')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (item.pic_type == 0)
                        ? (_openBlock(), _createBlock(_component_van_uploader, {
                            key: 0,
                            modelValue: $setup.storeInfo.result[index].pic_ids,
                            "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].pic_ids) = $event),
                            "max-count": item.photo_num,
                            "after-read": $setup.upload
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "max-count", "after-read"]))
                        : (_openBlock(), _createBlock(_component_van_uploader, {
                            key: 1,
                            modelValue: $setup.storeInfo.result[index].pic_ids,
                            "onUpdate:modelValue": ($event: any) => (($setup.storeInfo.result[index].pic_ids) = $event),
                            "max-count": item.photo_num,
                            "after-read": $setup.upload,
                            capture: "camera"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "max-count", "after-read"]))
                    ]))
                  : _createCommentVNode("", true),
                (item.check_type === 'check_assign')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_van_image, {
                          width: "100%",
                          height: "100%",
                          fit: "contain",
                          src: $setup.storeInfo.result[index].src,
                          onClick: ($event: any) => ($setup.storeInfo.result[index].onClick($setup.storeInfo.result[index]))
                        }, null, 8, ["src", "onClick"])
                      ]),
                      _createVNode(_component_uf_signature, {
                        show: $setup.storeInfo.result[index].popupShow,
                        "onUpdate:show": ($event: any) => (($setup.storeInfo.result[index].popupShow) = $event),
                        onConfirm: ($event: any) => ($setup.storeInfo.result[index].onConfirm($event, $setup.storeInfo.result[index]))
                      }, null, 8, ["show", "onUpdate:show", "onConfirm"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_van_divider)
              ], 64))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}